import { Component, Injector, OnInit, ElementRef, ViewChild } from '@angular/core';
import { inject } from '@angular/core';
import { Database, ref, set, child, get, onValue, update } from "@angular/fire/database";
import { BaseComponent } from 'src/app/shared/baseComponent';
import { getAuth, signInWithPopup, GoogleAuthProvider } from "@angular/fire/auth";

const VALID_DOMAINS = ['cellpodium.com', 's5-tech.com']

@Component({
  selector: 'app-surveys',
  templateUrl: './surveys.component.html',
  styleUrls: ['./surveys.component.css']
})
export class SurveysComponent extends BaseComponent implements OnInit {
  surveys: any = []
  survey: any = {}
  surveyKey = ''
  option: any = {}
  showModal = false
  showModalName = false
  database = inject(Database);
  isAuthenticatedWithFirebase = false
  private googleAuthProvider = new GoogleAuthProvider();

  constructor(injector: Injector) {
    super(injector)
  }
  async ngOnInit(): Promise<void> {
    this.isAuthenticatedWithFirebase = getAuth().currentUser != null
    if (this.isAuthenticatedWithFirebase) {
      await this.onSuccessfullLogin()
    }
  }
  async signInWithGoogle() {
    const auth = getAuth();
    try {
      const credential = await signInWithPopup(auth, this.googleAuthProvider)
      if (credential.user.email == null) {
        await auth.signOut();
        return
      }
      const domain = credential.user?.email.split('@')[1]?.toLowerCase();
      if (!VALID_DOMAINS.includes(domain)) {
        await auth.signOut();
        return
      }
      this.isAuthenticatedWithFirebase = true
      await this.onSuccessfullLogin()
    } catch (error: any) {
      alert((error as Error).message)
    }
  }
  private async onSuccessfullLogin() {
    await this.getData()
  }
  async getData() {
    this.loader.show()
    const avatarsRef = ref(this.database, 'surveys');
    const snapshot = await get(avatarsRef);
    if (snapshot.exists()) {
      this.surveys = snapshot.val();
    }
    this.loader.hide()
  }
  async updateSurvey() {
    await set(ref(this.database, 'surveys/'+this.surveyKey), this.survey);
    this.showModal = false
  }
  editSurvey(surveyKey: any, survey: any) {
    this.surveyKey = surveyKey
    this.survey = survey
    this.showModal = true
  }
  removeSurvey(survey: any) {
    delete this.surveys[survey]
    update(ref(this.database, 'surveys'), this.surveys);
  }
  selectOption(option: any) {
    this.option = option
  }
  addOption() {
    // loop through all options and find the highest id, then new id = highest id + 1
    let newId = 0
    let newSeqNo = 0
    this.survey.options.forEach((option: any) => {
      if (option.id > newId) {
        newId = option.id
      }
      if (option.seqNo > newSeqNo) {
        newSeqNo = option.seqNo
      }
    })
    newId += 1
    newSeqNo += 10
    this.option = {id: newId, name: '', seqNo: newSeqNo}
    this.survey.options.push(this.option)
  }
  deleteOption(option: any){
    this.survey.options = this.survey.options.filter((opt: any) => opt.id != option.id)
  }
  add(){
    this.showModalName = true
  }
  createSurvey() {
    this.survey = {question:"", description: "",image: "", hasMultipleAnswers: true, canChangeVote: false, options: []}
    this.surveys[this.surveyKey] = this.survey
    this.showModalName = false
    this.showModal = true
  }
}
